import React, {useMemo} from 'react';
import {connect} from "react-redux";
import {s3FeatureImagePath, THUMBNAIL_SIZES} from "../../../../../../misc/utils";
import FeatureName from "../../../../../visComponents/featureName";
import {SQFT_APPLIANCES_WITH_SUBMENU, SQFT_FEATURES} from "../../../../constants";
import {
  createApplianceFromFeature,
} from "../../../../helpers/featureHelper";
import {setSelectedCountertop} from "../../../../../../actions/sqftMenuFunctions";

const SqftNavFeaturesRow = (props) => {
  const {feature, featureGroup, index, style, setActiveItemIndex} = props;
  const {isActiveItem, setSelectedCountertop} = props;
  const dbFeature = feature.part.dbFeature;

  const className = useMemo(() => isActiveItem ? 'lightbox-option-single lightbox-option-selected' : 'lightbox-option-single', [isActiveItem]);
  const imageUrl = useMemo(() => dbFeature.thumbnailUrl ? s3FeatureImagePath(dbFeature, THUMBNAIL_SIZES.medium) : dbFeature.customThumbnail, [dbFeature]);

  const handleButtonClick = (e) => {
    void e
    setActiveItemIndex(index);
    if (SQFT_APPLIANCES_WITH_SUBMENU.includes(featureGroup.partId)) {
      createApplianceFromFeature(feature.part);
    } else if (featureGroup.partId === SQFT_FEATURES.countertop) {
      setSelectedCountertop(dbFeature.id);
    }
  };

  return (
    <div className={className} style={style} key={index}
         onClick={(e) => handleButtonClick(e)}>
      <div className="upper-image">
        {imageUrl ? <img src={imageUrl} className="accItem-image__block-img" alt=""/> : null}
      </div>
      <div className="upper-content">
        <div className="lightbox-title">
          <FeatureName feature={feature.part} maxLength={23}/>
        </div>
        <div className="lightbox-description-text-rectangular">

        </div>
      </div>
    </div>

  )
};

const mapStateToProps = (store) => {
  void store

  return {

  };
};

const mapDispatchToProps = {
  setSelectedCountertop
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavFeaturesRow);
